import { resolveStatus } from '../utils/schedule';
import { getJerusalemParts } from '../utils/date';
import { fetchJson } from './network';

const CALENDAR_API_BASE_URL = (
  process.env.REACT_APP_CALENDAR_API_BASE_URL ||
  'https://new.yk8.org.il/api/calendar/v1'
).replace(/\/$/, '');
export async function getSharedCalendarDays(start, days = 8, { signal } = {}) {
  const result = await fetchJson(
    `${CALENDAR_API_BASE_URL}/days?start=${encodeURIComponent(start)}&days=${days}`,
    { signal, timeoutMs: 20000 }
  );

  if (!Array.isArray(result?.days)) {
    throw new Error('Calendar response did not include days.');
  }

  return result;
}

export function mapSharedZmanim(day) {
  return Object.fromEntries((day?.zmanim || []).map((item) => {
    const local = getJerusalemParts(item.at);
    return [item.key, `${local.hours}${String(local.minutes).padStart(2, '0')}`];
  }));
}

export function mapSharedSchedule(day) {
  return (day?.schedule || []).map((item) => {
    const start = getJerusalemParts(item.startsAt);
    return {
      crfd1_title: item.title,
      crfd1_subtitle: item.subtitle,
      crfd1_location: item.location,
      crfd1_sourceid: item.sourceId,
      crfd1_occurrenceid: item.occurrenceId,
      hours: start.hours,
      minutes: start.minutes,
      startsAt: item.startsAt,
      endsAt: item.endsAt,
      type: item.sourceType,
      status: resolveStatus(item.startsAt, item.endsAt, item.sourceType === 'tfila' ? 10 : 5)
    };
  });
}
